import * as RLabel from '@radix-ui/react-label';
import { forwardRef } from 'react';

import { cn } from '@/lib/utils';

export const Label = forwardRef<
  React.ElementRef<typeof RLabel.Root>,
  React.ComponentPropsWithoutRef<typeof RLabel.Root>
>(({ className, ...props }, ref) => (
  <RLabel.Root
    ref={ref}
    className={cn('text-sm font-medium leading-none', className)}
    {...props}
  />
));
Label.displayName = 'Label';
